<template>
    <div class="paymentPanel">
        <div class="paymentInfo">
            <span>订单名称: 课程-{{orderInfo.courseName}}</span>
            <span>订单编号: {{orderInfo.orderSn}}</span>
            <span>支付金额：<b class="money">¥{{orderInfo.money}}</b></span>
        </div>
        <div class="paymentBtns">
            <router-link :to="{path:'/user',query:{m:'order'}}" class="payType">
                <img src="../../assets/icon_xxzf.png" />
            </router-link>
            <!-- <a class="payType" @click="openPayFc(103)">
                <img src="../../assets/icon_xxzf.png" />
            </a> -->
            <span class="payType" @click="openPayFc(102)">
                <img src="../../assets/icon_zfb.png" />
            </span>
            <span class="payType" @click="openPayFc(101)">
                <img src="../../assets/icon_wx.png" />
            </span>
            <!-- <a class="payType" @click="openPayFc(104)">
                <img src="../../assets/icon_yl.png" />
            </a> -->
        </div>
        <div class="paymentTip">友情提示:请在12小时内完成支付,有问题请联系客服</div>
    </div>
    <!-- 支付浮层 start -->
    <div class="fc" v-if="payFcStatus">
        <div class="fc_box">
            <div class="fc_top">
                <p class="fc_tit">{{ fcTit }}</p>
                <img src="../../assets/close_fc.png" class="close" @click="closeFc()" alt="">
            </div>
            <!-- 支付中 -->
            <div v-if='payStatus == 1'>
                <div class="ewm" v-if='payStatus == 1 || payStatus == 2'>
                    <qrcode-vue :value="result.payCode" size='184'  ></qrcode-vue>
                </div>
                <p class="fc_exp" v-if='payStatus == 1'>{{ formatSeconds(countDown) }}分钟后过期，请尽快完成支付</p>
            </div>
            <!-- 已过期 -->
                <div v-if='payStatus == 2'>
                    <div class="ewm" v-if='payStatus == 1 || payStatus == 2'>
                        <qrcode-vue :value="result.payCode" size='184'  ></qrcode-vue>
                        <div class="ewm_fc" v-if='payStatus == 2'>
                            <img src="../../assets/icon_sx.png" class="icon_sx" alt="" @click="refreshCode()">
                        </div>
                    </div>
                    <p class="fc_exp clo_red" v-if='payStatus == 2'>已超时，请刷新后进行支付</p>
                </div>
            <!-- 支付成功 -->
            <div v-if='payStatus == 3'>
                <img src="../../assets/icon_zfwc.png" class="icon_zfwc" alt="">
                <p class="pay_suc">交易付款成功，正在跳转至个人中心</p> 
            </div>
            
            <!-- 线下支付 -->
            <div v-if='payStatus ==  4'>
                <img src="../../assets/icon_dsh.png" class="icon_zfwc" alt="">
                <p class="pay_suc">提交成功，请等待审核…</p>
            </div>
            
        </div>
    </div>
    <!-- 支付浮层 end -->
</template>

<script>
import { createCode,payQuery } from "../../server/pay";
import QrcodeVue from 'qrcode.vue'

export default {
    data() {
        return {
            payFcStatus: false,
            fcTit: '',
            payStatus: 1,//1是待支付2是过期3是成功4是线下,
            result:'',
            type: '',
            clickStatus: true,
            countDown:0
        };
    },
    components:{
        QrcodeVue
    },
    computed: {
        orderInfo() {
            // console.log('orderInfo',this.$store.state.paymentOrderInfo);
            return this.$store.state.paymentOrderInfo;
        },
    },
    methods: {
        openPayFc(type){
            if( !this.clickStatus ) return;
            console.log(type);
            //101 微信 102 支付宝 103 线下 104 银联
            switch (type) {
                case 101:
                    this.fcTit = '微信扫码支付'
                    break;
                case 102:
                    this.fcTit = '支付宝扫码支付'
                    break;
                case 103:
                    this.fcTit = '线下支付'
                    break;
                case 104:
                    this.fcTit = '银联扫码支付'
                    break;
                default:
                    break;
            }
            this.clickStatus = false
            if( type == 101 || type == 102 ){
                let params = {
                    "payType": type,
                    "orderSn": this.orderInfo.orderSn
                }
                createCode(params).then(res => {
                    if( res !=false ){
                        this.result = res
                        this.payStatus = 1
                        //订单状态
                        this.getPayStatus();
                        this.payFcStatus = true
                        this.type = type
                    }
                    this.clickStatus = true
                })               
            }
            

        },
        getPayStatus(){
            this.countDown = this.result.validTime;
            this.countDownTimer = setInterval(async () => {
                this.countDown -= 1;
                if (this.countDown <= 0) {
                    // 已过期，清除倒计时Timer
                    clearInterval(this.countDownTimer);
                    this.payStatus = 2
                }else{
                    let params = {
                        "orderSn": this.orderInfo.orderSn
                    }
                    let queryResult = await payQuery(params)
                    console.log('queryResult',queryResult);
                    if(queryResult.status == 202 ){
                        clearInterval(this.countDownTimer);
                        this.payStatus = 3
                        setTimeout(() =>{
                            //跳转个人中心
                            this.$router.push({path:'/user',query:{m:'order'}});
                        },3000)
                    }

                }
            }, 1000);
        },
        //关闭浮层
        closeFc(){
            this.payFcStatus = false
            clearInterval(this.countDownTimer);
        },
        //刷新二维码
        async refreshCode(){
            let params = {
                "payType": this.type,
                "orderSn": this.orderInfo.orderSn
            }
            this.result = await createCode(params)
            // console.log(this.result);
            this.payStatus = 1
            //订单状态
            this.getPayStatus();
        },
        //过期时间换算
        formatSeconds(value) {
            var secondTime = parseInt(value);// 秒
            var minuteTime = 0;// 分
            var hourTime = 0;// 小时
            if(secondTime > 60) {//如果秒数大于60，将秒数转换成整数
                //获取分钟，除以60取整数，得到整数分钟
                minuteTime = parseInt(secondTime / 60);
                //获取秒数，秒数取佘，得到整数秒数
                secondTime = parseInt(secondTime % 60);
                //如果分钟大于60，将分钟转换成小时
                if(minuteTime > 60) {
                    //获取小时，获取分钟除以60，得到整数小时
                    hourTime = parseInt(minuteTime / 60);
                    //获取小时后取佘的分，获取分钟除以60取佘的分
                    minuteTime = parseInt(minuteTime % 60);
                }
            }
            var result = "" + parseInt(secondTime) + "秒";
    
            if(minuteTime > 0) {
                result = "" + parseInt(minuteTime) + "分" + result;
            }
            if(hourTime > 0) {
                result = "" + parseInt(hourTime) + "小时" + result;
            }
            return result;
        }
    },
}
</script>

<style scoped>
.paymentPanel {
    width: 1200px;
    margin: 0 auto;
    background: #fff;
    box-shadow: 0px 0px 20px 0px rgba(0, 0, 0, 0.0800);
    padding: 0 40px;
    align-items: center;
    margin-bottom: 100px;
}

.paymentPanel .paymentInfo {
    height: 76px;
    line-height: 76px;
    border-bottom: 1px solid #EDEDED;
    text-align: center;
}

.paymentPanel .paymentInfo span {
    display: inline-block;
    color: #151515;
    font-size: 16px;
    margin-right: 30px;
}

.paymentPanel .paymentInfo .money {
    color: #FF6100;
    font-weight: bold;
    font-size: 22px;
}

.paymentPanel .paymentBtns {
    padding-top: 80px;
    padding-bottom: 129px;
    text-align: center;
}

.paymentPanel .paymentBtns .payType {
    display: inline-block;
    margin-right: 60px;
    cursor: pointer;
    border: 1px solid #D7D7D7;
    padding: 15px 30px;
    border-radius: 4px;
}

.paymentPanel .paymentBtns .payType:hover {
    border: 1px solid #003399;
}

.paymentPanel .paymentBtns .payType:last-child {
    margin-right: 0;
}

.paymentPanel .paymentBtns .payType img {
    display: inline-block;
    width: 140px;
    height: 50px;
}

.paymentPanel .paymentTip {
    color: #737373;
    font-size: 14px;
    display: block;
    text-align: center;
    padding-bottom: 30px;
}
.ewm{
    margin-top: 50px;margin-left: 310px;border: 2px solid #EDEDED;width: 200px;height: 200px;box-sizing: border-box;padding: 8px;position: relative;
}
.ewm_img{
    width: 184px;height: 184px;
}
.ewm_fc{
    position: absolute;top: 8px;left: 8px;right: 8px;bottom: 8px;background-color: rgba(255, 255, 255, 0.3);
}
.fc_exp{
    font-size: 14px;color: #737373;margin-top: 32px;text-align: center;
}
.clo_red{
    color: #FF6100;
}
.icon_sx{
    width: 40px;height: 40px;position: absolute;top: 50%;left: 50%;margin-top: -20px;margin-left: -20px;
}
.icon_zfwc{
    width: 84px;height: 84px;margin: 0 auto;margin-top: 89px;display: block;
}
.pay_suc{
    margin-top: 27px;text-align: center;color: #44D7B6;font-size: 28px;
}
</style>